import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function TituloPasso({ titulo, descricao }: { titulo: string; descricao: string }) {
  return (
    <header className="space-y-1">
      <h2 className="text-xl font-semibold tracking-tight">{titulo}</h2>
      <p className="text-sm leading-relaxed text-muted-foreground">{descricao}</p>
    </header>
  );
}

export function Grade({
  children,
  colunas = 2,
  className,
}: {
  children: ReactNode;
  colunas?: 1 | 2 | 3;
  className?: string;
}) {
  /*
   * Em celular — em pé ou deitado — e em tablet o cartão ocupa a linha inteira:
   * só a partir de 1024 px as colunas voltam a valer.
   */
  return (
    <div
      className={cn(
        'grid gap-3',
        colunas === 1 && 'grid-cols-1',
        colunas === 2 && 'grid-cols-1 lg:grid-cols-2',
        colunas === 3 && 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function AmostraCor({ cor, className }: { cor: string; className?: string }) {
  return (
    <span
      className={cn('block size-7 rounded-md border border-black/10 shadow-inner', className)}
      style={{ background: cor }}
    />
  );
}

/** Mock de página usado nas escolhas visuais (formato, dias por página). */
export function MockPagina({
  largura,
  altura,
  faixas,
  compacto,
  orientacao = 'RETRATO',
}: {
  largura: number;
  altura: number;
  faixas: number;
  compacto?: boolean;
  /** Paisagem deita o mock: a folha vira mais larga que alta. */
  orientacao?: 'RETRATO' | 'PAISAGEM';
}) {
  const l = orientacao === 'PAISAGEM' ? altura : largura;
  const a = orientacao === 'PAISAGEM' ? largura : altura;
  const escala = 46 / Math.max(l, a);
  const w = l * escala;
  const h = a * escala;
  const passoFaixa = (h - 8) / faixas - 3;

  return (
    <div
      className="relative overflow-hidden rounded-[3px] border border-border bg-white"
      style={{ width: w, height: h }}
      aria-hidden
    >
      {Array.from({ length: faixas }).map((_, i) => (
        <div
          key={i}
          className="absolute left-1 right-1 rounded-[2px] border border-current/10 bg-current/[0.06]"
          style={{ top: 4 + i * (passoFaixa + 3), height: passoFaixa }}
        >
          <span className="absolute left-1 top-1 h-[2px] w-1/3 rounded bg-current/30" />
          <span className="absolute bottom-1 left-1 right-1 h-[1px] bg-current/15" />
          <span className="absolute bottom-2.5 left-1 right-1 h-[1px] bg-current/15" />
          {!compacto ? <span className="absolute bottom-4 left-1 right-1 h-[1px] bg-current/15" /> : null}
        </div>
      ))}
    </div>
  );
}
